import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { benefits, coachingAreas, faqs } from '../data/content';
import { FeatureCard, SectionHeading } from '../components/Shared';

const { FiArrowRight, FiPlay, FiCheckCircle, FiMessageCircle, FiTarget, FiBarChart2 } = FiIcons;

export default function Home() {
  return (
    <>
      <section className="hero">
        <div className="hero-copy">
          <span className="eyebrow">Purposeful development, every day</span>
          <h1>Your Personal AI Coach for <em>Continuous Growth</em></h1>
          <p>Build better habits, strengthen your leadership, clarify your goals and make continuous progress through personalised AI coaching.</p>
          <div className="button-row">
            <Link className="button" to="/pricing">Start Coaching <SafeIcon icon={FiArrowRight} /></Link>
            <Link className="button secondary" to="/how-it-works"><SafeIcon icon={FiPlay} /> See How It Works</Link>
          </div>
          <div className="trust-row">
            <span><SafeIcon icon={FiCheckCircle} /> Secure payments</span>
            <span><SafeIcon icon={FiCheckCircle} /> Cancel future renewal</span>
            <span><SafeIcon icon={FiCheckCircle} /> Mobile ready</span>
          </div>
        </div>
        <div className="coach-preview">
          <div className="preview-top"><span className="online-dot" /> Coaching session <span>Private</span></div>
          <div className="coach-message">What would make today feel like meaningful progress?</div>
          <div className="user-message">I want to prepare for a challenging leadership conversation.</div>
          <div className="reflection-card">
            <SafeIcon icon={FiTarget} />
            <div><strong>Your focus</strong><p>Communicate clearly while remaining curious.</p></div>
          </div>
          <div className="preview-stats">
            <div><SafeIcon icon={FiMessageCircle} /><strong>24</strong><span>Reflections</span></div>
            <div><SafeIcon icon={FiBarChart2} /><strong>72%</strong><span>Goal progress</span></div>
          </div>
        </div>
      </section>

      <section className="section">
        <SectionHeading eyebrow="Why it works" title="Coaching that fits the way you grow" text="A focused, accessible space for reflection, action and continuous learning." />
        <div className="grid three">{benefits.map(([icon, title, text]) => <FeatureCard key={title} icon={icon} title={title} text={text} />)}</div>
      </section>

      <section className="section tinted">
        <SectionHeading eyebrow="How it works" title="From intention to action in four steps" />
        <div className="steps">
          {['Choose your subscription', 'Create your account and pay securely', 'Receive your coaching access', 'Reflect regularly and track progress'].map((step, index) => (
            <article key={step}><span>{index + 1}</span><h3>{step}</h3></article>
          ))}
        </div>
      </section>

      <section className="section">
        <SectionHeading eyebrow="Development areas" title="Grow where it matters most" />
        <div className="area-grid">{coachingAreas.map((area) => <Link to="/coaching" key={area}>{area}<SafeIcon icon={FiArrowRight} /></Link>)}</div>
      </section>

      <section className="section corporate-banner">
        <div><span className="eyebrow light">For organisations</span><h2>Make high-quality development more accessible.</h2><p>Support leaders, employees, graduates and talent programmes with scalable coaching access.</p></div>
        <Link className="button gold" to="/organisations">Explore organisational plans</Link>
      </section>

      <section className="section">
        <SectionHeading eyebrow="Common questions" title="Everything you need to get started" />
        <div className="faq-list">{faqs.slice(0, 6).map(([question, answer]) => <details key={question}><summary>{question}</summary><p>{answer}</p></details>)}</div>
      </section>

      <section className="section final-cta">
        <span className="eyebrow light">Your next step</span>
        <h2>Make continuous growth part of your routine.</h2>
        <p>Start building clarity, confidence and momentum today.</p>
        <Link className="button gold" to="/pricing">Start Coaching <SafeIcon icon={FiArrowRight} /></Link>
      </section>
    </>
  );
}